var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"header-simple"},[_c('div',{staticClass:"header-wrapper"},[_c('button',{staticClass:"btn-back",on:{"click":function($event){return _vm.onClickBack()}}},[_c('img',{attrs:{"src":require('@/assets/img/ico_back.svg'),"alt":""}})]),_vm._v(" "),_c('h3',{staticClass:"header-title"},[_vm._v(_vm._s(_vm.$t(_vm.pageTitle)))])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-26c56d92","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/layouts/TitleHeader.vue
// module id = null
// module chunks = 